/* RESPONSIBLE TEAM: team-standalone */
import { default as StandaloneBaseWorkflowRoute } from 'embercom/routes/apps/app/standalone/channels/base-workflow';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import { get } from 'embercom/lib/ajax';

export default class Route extends StandaloneBaseWorkflowRoute {
  @service declare router: RouterService;
  @service declare appService: AppService;

  async beforeModel() {
    if (this.appService.app.canUseFinProcedures) {
      let params = this.paramsFor(this.routeName) as { id?: string };
      if (params.id) {
        try {
          let response = await get('/ember/procedures', {
            app_id: this.appService.app.id,
            ruleset_id: params.id,
          });
          this.router.transitionTo(
            'apps.app.standalone.procedures.procedure',
            (response as { id: string }).id,
          );
          return;
        } catch {
          // If lookup fails (e.g., not a valid procedure), fall through to original behavior
        }
      }
    }

    super.beforeModel();
  }
}
